<div class="card p-0 border-1 border-round border-bluegray-200">
  <div class="grid w-full pt-2 pl-3">
    <div class="field col-12 md:col-6 lg:col-2 text-l font-normal">
      <label id="fiscalYearLabel" class="flex">Fiscal Year</label>
      <p-dropdown #fiscalYearDropdown id="fiscalYearDropdown"
                  ariaLabelledBy="fiscalYearLabel"
                  [options]="fiscalYearOptions"
                  optionLabel="fullFiscalYear"
                  [(ngModel)]="selectedFiscalYear"
                  (onChange)="fiscalYearChange()"
                  [placeholder]="'Pick a Fiscal Year'">
      </p-dropdown>
    </div>

    <div class="field col-12 md:col-6 lg:col-2">
      <label id="reportingPeriodLabel" class="flex">Reporting Period</label>
      <p-dropdown #reportingPeriodDropdown id="reportingPeriodDropdown"
                  ariaLabelledBy="reportingPeriodLabel"
                  [options]="reportingPeriodOptions"
                  [(ngModel)]="selectedReportingPeriod"
                  [disabled]="!selectedFiscalYear"
                  (onChange)="reportingPeriodChange()"
                  [placeholder]="'Pick a Reporting Period'">
      </p-dropdown>
    </div>

    <div class="field col-12 md:col-6 lg:col-3">
      <label id="entityTypeLabel" class="flex text-l">Entity Type</label>
      <p-dropdown #entityTypeDropdown id="entityTypeDropdown"
                  ariaLabelledBy="entityTypeLabel"
                  [options]="entityTypeOptions"
                  [(ngModel)]="selectedEntityType"
                  [disabled]="!selectedFiscalYear || !selectedReportingPeriod"
                  (onChange)="entityTypeChange()"
                  [placeholder]="'Pick an Entity Type'">
      </p-dropdown>
    </div>

    <div class="field col-12 md:col-6 lg:col-3">
      <label id="entityNameLabel" class="flex text-l">Entity Name</label>
      <p-dropdown #entitiesDropdown id="entityNameDropdown"
                  ariaLabelledBy="entityNameLabel"
                  [options]="data"
                  [lazy] = "true"
                  (onLazyLoad)="onLazyLoad($event)"
                  [(ngModel)]="selectedCDSCode"
                  [disabled]="!selectedFiscalYear || !selectedReportingPeriod || !selectedEntityType || selectedEntityTypeCDE || selectedEntityTypeSBE"
                  [filter]="true"
                  [filterBy]="'label,value'"
                  [placeholder]="selectedEntityTypeCDE ? 'All' : selectedEntityTypeSBE ? 'State Board of Education Charters' : 'Pick an Entity'"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="38"
                  [virtualScrollOptions]="options">
      </p-dropdown>
    </div>

    <div class="field col-12 md:col-6 lg:col-2 flex justify-content-end pt-5">
      <p-button id="applyFiltersButton" type="button" label="Apply filters" ariaLabel="apply filters"
                styleClass="p-button p-button-primary p-button-sm" icon="pi pi-check"
                (onClick)="applyFilters()"
                [disabled]="!selectedFiscalYear || !selectedReportingPeriod || !selectedEntityType || (!selectedCDSCode && !selectedEntityTypeCDE && !selectedEntityTypeSBE)"></p-button>
    </div>
  </div>

  <div *ngIf="(rollupDatImport && rollupDatImport.hasValue) || (rollupDataExtract && rollupDataExtract.hasValue)" class="p-0 border-top-1 border-black-alpha-20 pt-2" style="background-color: #fff6e5;">
    <div *ngIf="rollupDataExtract && rollupDataExtract.hasValue" class="grid w-full pl-3 pb-0 border-6">
      <div class="field col-12 md:col-6 lg:col-10 pt-3">
        <span class="flex text-l">{{ rollupAvailableTextDesc }} Data Extract (Excel File).</span>
      </div>

      <div class="col-12 md:col-6 lg:col-2 flex justify-content-end">
        <p-button type="button" label="Download" ariaLabel="download"
                  styleClass="p-button-outlined p-button-primary p-button-sm" icon="pi pi-download"
                  [loading]="rollupDataExtract.loading" [disabled]="rollupDataExtract.loading"
                  (onClick)="downloadRollupBlob(rollupDataExtract)"></p-button>
      </div>
    </div>

    <div *ngIf="rollupDatImport && rollupDatImport.hasValue" class="grid w-full pl-3 pb-0 border-6">
      <div class="field col-12 md:col-6 lg:col-10 pt-3">
        <span class="flex text-l">{{ rollupAvailableTextDesc }} Single Export (Dat File).</span>
      </div>

      <div class="col-12 md:col-6 lg:col-2 flex justify-content-end">
        <p-button type="button" label="Download" ariaLabel="download"
                  styleClass="p-button-outlined p-button-primary p-button-sm" icon="pi pi-download"
                  [loading]="rollupDatImport.loading" [disabled]="rollupDatImport.loading"
                  (onClick)="downloadRollupBlob(rollupDatImport)"></p-button>
      </div>
    </div>
  </div>
</div>
